export default {
  loading: "جارٍ التحميل...",

  delivery: "التوصيل",
  order: "طلب",

  delivery_success: "تم التوصيل بنجاح",
  delivery_completed_msg: "شكراً لك! تم إكمال التوصيل.",

  invalid_link_title: "❌ رابط غير صالح",
  invalid_link_msg: "رابط التوصيل غير صالح.",

  delivery_completed_title: "✅ تم التوصيل",
  delivery_completed_msg_short: "هذا الرابط لم يعد نشطاً.",

  link_expired_title: "⌛ انتهت صلاحية الرابط",
  contact_restaurant: "يرجى التواصل مع المطعم.",

  navigate_location: "التوجه إلى الموقع",
  gps_enabled: "📍 الملاحة GPS مفعلة",
  start_navigation: "ابدأ الملاحة",

  restaurant: "المطعم",
  call: "اتصال",

  order_items: "عناصر الطلب",

  payment: "الدفع",
  status: "الحالة",
  mark_payment_received: "تم استلام الدفع",

  complete_delivery: "إكمال التوصيل",
  enter_otp: "أدخل رمز OTP",
  mark_delivered: "تم التسليم",
};